import yup from '../../../config/yup';

export const googleSpreadsheetWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('googleSpreadsheetWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    sheetName: yup.string().required('Sheet Name is required'),
    credential: yup.string(),
    spreadsheetId: yup.string().matches(/^[a-zA-Z0-9_-]+$/, {
      message: 'Spreadsheet ID must contain only letters, numbers, underscores, and hyphens',
    }),
    saveMode: yup.string(),
  }),
});
